import {Injectable, Injector} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '@abstract/api.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {ErrorLoggerService} from '@services/error-logger.service';

/**
 * Допуск к странице разрешен только если в URL есть токен в качестве параметра, например
 * http://path/to/page?token=3DcRT0NjMWM4--M%3D75AEfjDDi9vPBNbr9vN_1537254987
 *
 * Токен будет проверяться и доступ разрешаться, только если токен валиден
 */

@Injectable()
export class ByTokenOnlyGuardService extends ApiService implements CanActivate {
    private tokenCheckUrl = 'password-restore/reset';

    constructor(
        http: HttpClient,
        logger: ErrorLoggerService,
        injector: Injector,
        private router: Router,
    ) {
        super(http, logger, injector);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const token = route.queryParams && route.queryParams.token ? route.queryParams.token : null;

        if (!token) {
            this.router.navigate(['/']);
            return false;
        }

        return this.get({
            url: this.tokenCheckUrl,
            id: token,
        }).pipe(
            map(() => true),
            catchError((error) => {
                this.router.navigate(['/']);
                return of(false);
            })
        );

    }
}
